module.exports = __webpack_public_path__ + "media/images/photograph-1cb1fa60.png";